import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { repDIDState, marketParamState } from 'state/userState';
import { formState } from 'state';
import ErrorBoundary from './ErrorBoundary';

export default function ErrorBoundaryWithState({ children }) {
  const {
    authRep: { RepDID: repDID } = {},
    repDID: sponsorRepDID,
    businessMarket: { name: selectedMarketName } = {},
    countryInfo: { name: selectedShippingCountryName } = {},
  } = useRecoilValue(formState);
  // const repDID = useRecoilValue(repDIDState);
  const loggedIn = !!repDID;
  const marketParam = useRecoilValue(marketParamState);

  return (
    <ErrorBoundary
      repDID={repDID}
      loggedIn={loggedIn}
      marketParam={marketParam}
      sponsorRepDID={sponsorRepDID}
      selectedMarketName={selectedMarketName}
      selectedShippingCountryName={selectedShippingCountryName}
    >
      {children}
    </ErrorBoundary>
  );
}
